import { render, staticRenderFns } from "./KlaviyoFormEmbed.vue?vue&type=template&id=ebbdcdfa&"
import script from "./KlaviyoFormEmbed.vue?vue&type=script&lang=ts&"
export * from "./KlaviyoFormEmbed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports